import $ from "cash-dom";
import {calculatePzpApi} from "../api/calculatePzp";

function debounce(func, timeout = 300) {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            func.apply(this, args);
        }, timeout);
    };
}

export const pzpAddressInputComponent = (rootPostalCity, rootRegion, rootPostalId, rootCityId, rootRegionId) => {
    const $postalCity = $(rootPostalCity);
    const $region = $(rootRegion);

    const postalInput = $postalCity.find('input').get(0);
    const postalContainer = $postalCity.find('.options-container').get(0);
    const postalOptions = $postalCity.find('.options').get(0);

    const regionInput = $region.find('input').get(0);

    const Postal = {
        async onInput() {
            const value = postalInput.value;

            if (value.length > 3) {
                postalContainer.classList.remove('hidden');
                postalOptions.innerHTML = `<div class="p-4">Načítavam...</div>`;

                const results = await calculatePzpApi.getAddressList(value);
                postalOptions.innerHTML = results
                    .map(({psc, obec, value, okres}) =>
                        `<button type="button" class="option p-4" data-postal-id="${psc.id}" data-city-id="${obec.id}" data-region-id="${okres.id}" data-region-value="${okres.name}">${value}</button>`
                    )
                    .join('\n');

                $postalCity.find('.option').on('click', (event) => {
                    const option = event.target;

                    postalInput.value = option.innerText;
                    regionInput.value = option.getAttribute('data-region-value');

                    $(rootPostalId).val(option.getAttribute('data-postal-id'));
                    $(rootCityId).val(option.getAttribute('data-city-id'));
                    $(rootRegionId).val(option.getAttribute('data-region-id'));

                    postalContainer.classList.add('hidden');
                });
            } else {
                postalContainer.classList.add('hidden');
            }
        },
    };

    postalInput.oninput = debounce(Postal.onInput);
};
